export default __webpack_public_path__ + "static/media/wait-grey.446608e5.svg";